var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-container"
  }, [_c('div', {
    staticClass: "cities-map"
  }, [_c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height - 30,
      "viewBox": ("0 30 " + (_vm.width + 10) + " " + (_vm.height - 30))
    }
  }, [_c('path', {
    staticClass: "cities-map__landmass",
    attrs: {
      "d": _vm.worldmapD
    }
  }), _vm._v(" "), _vm._l((_vm.nodes), function(node, i) {
    return _c('a', {
      key: node.id,
      staticClass: "cities-map__node",
      attrs: {
        "href": node.url,
        "title": node.label
      },
      on: {
        "mouseenter": function($event) {
          _vm.hoveredNodeID = node.id
        },
        "mouseleave": function($event) {
          _vm.hoveredNodeID = null
        }
      }
    }, [_c('circle', {
      attrs: {
        "r": "1.25",
        "fill": node.color,
        "cx": node.x,
        "cy": node.y
      }
    })])
  }), _vm._v(" "), (_vm.activeNode) ? _c('g', {
    staticClass: "cities-map__popup",
    attrs: {
      "transform": ("translate(" + (_vm.activeNode.x) + " " + (_vm.activeNode.y - 2.25) + ")")
    }
  }, [_c('path', {
    staticClass: "cities-map__triangle",
    attrs: {
      "d": "M0 0L0 -5L5 -5Z",
      "fill": _vm.activeNode.color
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": ("translate(" + _vm.activeTooltipOffset + " 0)")
    }
  }, [_c('rect', {
    attrs: {
      "x": (_vm.textWidth / 2) * -1,
      "y": "-9.5",
      "width": _vm.textWidth + _vm.textPadding * 2,
      "height": "7",
      "fill": _vm.activeNode.color
    }
  }), _vm._v(" "), _c('text', {
    ref: "nodeLabel",
    attrs: {
      "x": _vm.textPadding,
      "y": "-4.5"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.activeNode.label) + "\n          ")])])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "map-overlay"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02531a70","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/cities-map.vue
// module id = null
// module chunks = 